import PropTypes from "prop-types";
import React, { useEffect } from "react";

import { window } from "@swa-ui/browser/window";
import { logger } from "@swa-ui/log";

import {
  resetPersistedCarBookingData,
  resetPersistedCarProductData,
  setPersistedCarBookingData,
  setPersistedCarProductData,
  setPersistedSmartblockStateData,
} from "../carPersistence";
import { CARTRAWLER_SECTION_ID } from "../defines";
import { loadCarSection } from "../loadCarSection";

/**
 * This component commits the custom Angular element into the DOM for the Smartblock.
 * @param {*} props
 * @returns
 */
export const CarSection = (props) => {
  const { className, loadScript = true, options, touchpoint } = props;
  const site = process.env.SITE;

  useEffect(() => {
    window.addEventListener("ct-smartblock-event", handleCTEvents);

    if (loadScript) {
      loadCarSection(options);
    }

    return () => window.removeEventListener("ct-smartblock-event", handleCTEvents);
  }, [loadScript]);

  return (
    <div className={className} id={CARTRAWLER_SECTION_ID}>
      <ct-smartblock-sb4
        data-config-name={site === "corporate" ? "swabiz" : "southwest"}
        data-touchpoint={touchpoint}
      ></ct-smartblock-sb4>
    </div>
  );

  function handleCTEvents(event) {
    const {
      onAddCarToBasket,
      onBackToExtras,
      onReady,
      onRemoveCarFromBasket,
      onSearch,
      shouldSetSessionData,
    } = options || {};
    const { payload, type } = event.detail;

    switch (type) {
      case "GET_ADDON":
        shouldSetSessionData &&
          setPersistedSmartblockStateData({
            ...payload?.stateToRestore,
            dataSource: payload?.dataSource,
          });
        onSearch?.(payload);

        break;
      case "ADD_ADDON":
        shouldSetSessionData &&
          setPersistedSmartblockStateData({
            ...payload?.stateToRestore,
            dataSource: payload?.dataSource,
          });

        setPersistedCarBookingData(payload?.data?.book);
        setPersistedCarProductData(payload?.data?.product);
        onAddCarToBasket?.(payload);

        break;
      case "BACK_TO_EXTRAS":
        onBackToExtras?.();

        break;
      case "REMOVE_ADDON":
        shouldSetSessionData &&
          setPersistedSmartblockStateData({
            ...payload?.stateToRestore,
            dataSource: payload?.dataSource,
          });
        resetPersistedCarBookingData();
        resetPersistedCarProductData();

        onRemoveCarFromBasket?.();

        break;
      case "LOAD_EVENT":
        onReady?.();
        break;

      case "ON_ERROR":
        const { message, code, error } = payload || {};

        logger.error(message, {
          codes: code ? [code] : [],
          component: "CarSection",
          error,
        });

        break;
    }
  }
};

CarSection.propTypes = {
  /** CSS className to be used only for positioning the component by the consumer. */
  className: PropTypes.string,

  /** Flag to indicate if the Smartblock loader script should be executed immediately on component load. */
  loadScript: PropTypes.bool,

  /** Configuration object to render various layouts per use case. */
  options: PropTypes.object,

  /**
   * CarTrawler Smartblock multi-widget presentation selector, rendered as the `data-touchpoint` attribute on the
   * Smartblock element. "top" renders the carousel (above the fold), "bottom" renders the grid
   * (below the fold). When omitted, no attribute is rendered (backward compatible). This is
   * distinct from `options.touchpoint`, which is the CTStore entry-point identifier.
   */
  touchpoint: PropTypes.oneOf(["top", "bottom"]),
};
